import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { List, Grid } from "@mui/material";
import { Form, useFormikContext } from "formik";
import pageStyles from "../../pageStyles";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { Data } from "../../../store/usergroup/types";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import TextInput from "../../../common/formElements/TextInput";
import SelectDropDown, {
  Option,
} from "../../../common/formElements/SelectDropDown";
import PermissionForm from "./permissionForm";
import { useToastMessage } from "../../../effects/useToastMessage";

interface Props {
  id: string;
  mode?: any;
}

const UserGroupEditForm: React.FC<Props> = ({ id }) => {
  const classes = pageStyles();
  const { isSubmitting, errors } = useFormikContext();

  const mode = id ? "UPDATE" : "CREATE";

  // Show toast errors
  useToastMessage(isSubmitting, errors);

  const permissions = useSelector(
    (state: ApplicationState) => state.permission?.data?.data || []
  );

  return (
    <Form style={{ width: "100%" }}>
      <Grid
        container
        alignItems="flex-start"
        spacing={2}
        className={classes.formWrapper as string}
      >
        <Grid item xs={12}>
          <SectionWrapper isChild title="Role Info">
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextInput
                  fieldname="attributes.Name"
                  label="Role Name"
                  disabled={mode === "CREATE" ? false : true}
                />
              </Grid>
            </Grid>
          </SectionWrapper>

          <SectionWrapper isChild isWhiteBG title="Permissions">
            <Grid item xs={12}>
              <List>
                {Object.keys(permissions || {}).map((key: string, idx) => {
                  return (
                    <PermissionForm
                      key={key}
                      permissionKey={key}
                      permissions={permissions}
                    />
                  );
                })}
              </List>
            </Grid>
          </SectionWrapper>
        </Grid>

        <FormSubmitButtons />
      </Grid>
    </Form>
  );
};

export default UserGroupEditForm;
